module.exports = __webpack_public_path__ + "static/device_watch_apple_light-a3b4d020a0dd27056a4093e637aaea88.png";